import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Fire-and-forget: records the event server-side for the member's own account
// and Admin only. Never emailed to anyone. Never throws / never blocks the UI.
export function notify(type, summary, email, subject) {
  try {
    axios.post(`${API}/notify`, { type, summary, email, subject }).catch((e) => console.debug("notify send failed:", e?.message));
  } catch (e) { console.debug("notify error:", e?.message); }
}
